import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.7",
  "description": "Turborepo 1.7 focuses on improving developer experience by bringing more clarity to your tasks.",
  "date": "2023/01/11",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 1.7 focuses on improving developer experience by bringing more clarity to your tasks:"
  }, {
    "heading": "",
    "content": "Improved support for long running tasks: Use persistent: true to mark non-terminating tasks so that turbo can alert you if you have dependencies on them."
  }, {
    "heading": "",
    "content": "Better clarity for outputs: You'll now always need to declare your task outputs, improving transparency to what your tasks will cache."
  }, {
    "heading": "",
    "content": "Globally installable: Install once, use everywhere. Turborepo can now be installed globally, and ran from any directory, not just from your repo root."
  }, {
    "heading": "",
    "content": "“Error only” output mode: Quiet your output logs to only show when a task fails."
  }, {
    "heading": "",
    "content": "Update today by running npm install turbo@latest, or by installing globally NEW and running the set-default-outputs codemod."
  }, {
    "heading": "schedule-your-long-running-tasks-with-confidence",
    "content": "To avoid misconfigurations that could result in tasks that never run, you can now tell Turborepo about tasks that won't exit on their own (like dev scripts) with a persistent: true configuration option. When this config is set on a task, Turborepo will ensure no other task can depend on this task. This is useful for dev tasks or test runners with --watch flags."
  }, {
    "heading": "schedule-your-long-running-tasks-with-confidence",
    "content": "Previously, if Task B depended on a persistent Task A, Task B would never execute, because Task A never exited. By declaring Task A as persistent, Turborepo will prevent this error scenario from happening."
  }, {
    "heading": "schedule-your-long-running-tasks-with-confidence",
    "content": "Before this release, we had been recommending the use of turbo run <task> --parallel for persistent tasks. With --parallel, turbo would ignore your dependency graph and execute all your tasks at once."
  }, {
    "heading": "schedule-your-long-running-tasks-with-confidence",
    "content": "While --parallel did provide a helpful escape hatch, it meant that users had to tell Turborepo how to run their tasks rather than declaring what a task is."
  }, {
    "heading": "schedule-your-long-running-tasks-with-confidence",
    "content": "Rather than throwing away your entire topological dependency graph, it's much more precise for Turborepo to keep your dependency graph while guaranteeing that you don't depend on a process that won't exit with persistent: true."
  }, {
    "heading": "global-turbo",
    "content": "You can now run your Turborepo tasks from anywhere in your project once you've installed turbo globally. To do so, use:"
  }, {
    "heading": "global-turbo",
    "content": "turbo will now work in any project. To find your local turbo version, turbo will walk through a few steps, always looking upward from your current directory:"
  }, {
    "heading": "global-turbo",
    "content": "Find the nearest turbo.json."
  }, {
    "heading": "global-turbo",
    "content": "If one is not found, find the first package.json with a workspaces property."
  }, {
    "heading": "global-turbo",
    "content": "If one is not found, find the first package.json."
  }, {
    "heading": "global-turbo",
    "content": "Your globally installed version of turbo will only be used when a locally installed version of turbo does not exist or cannot be found."
  }, {
    "heading": "global-turbo",
    "content": "turbo --version and turbo bin will show you the version and binary location, respectively, of the copy of turbo that will execute your tasks.\nAdditionally, running with -vv or --verbosity=2 will always show if your local, or global turbo is being used."
  }, {
    "heading": "declare-your-outputs-for-improved-clarity",
    "content": "Previously, if you did not specify an outputs key for a task, Turborepo would automatically attempt to cache all files in the dist/ and build/ directories."
  }, {
    "heading": "declare-your-outputs-for-improved-clarity",
    "content": "This worked well for build tasks of specific frameworks, but this implicit behavior did not scale well as it applied to all tasks. We've found that, across the many developers, teams, projects, and codebases using Turborepo, the assumption to automatically cache dist/ and build/ directories was causing problems for users."
  }, {
    "heading": "declare-your-outputs-for-improved-clarity",
    "content": "In version 1.7, this behavior is removed and you will now need to explicitly tell turborepo what to cache."
  }, {
    "heading": "declare-your-outputs-for-improved-clarity",
    "content": "If you were relying on the default cache output in Turborepo versions below 1.7, you can get the same behavior by running the @turbo/codemod set-default-outputs codemod:"
  }, {
    "heading": "declare-your-outputs-for-improved-clarity",
    "content": "Also note that you will no longer need to specify outputs: [] because not caching anything is now the default behavior. The codemod will also remove this configuration from your tasks."
  }, {
    "heading": "errors-only-output-mode-for-quieter-logs",
    "content": "To bring visibility to errors, community member @dobesv contributed a solution to only show errors instead of all logs from a task run. While debugging a pipeline, --output-logs=errors-only can be used to keep your signal-to-noise ratio high so you can focus on ensuring successful runs for your pipelines.\nThis can be used as a configuration option or as a CLI flag"
  }, {
    "heading": "community",
    "content": "Since releasing Turborepo v1.6 and merging with Turbopack, we've seen incredible adoption and community growth:"
  }, {
    "heading": "community",
    "content": "18.7k+ GitHub Stars"
  }, {
    "heading": "community",
    "content": "750k weekly NPM downloads"
  }, {
    "heading": "community",
    "content": "30 years of compute time saved through Remote Caching on Vercel"
  }, {
    "heading": "community",
    "content": "Turborepo is the result of the combined work of all of our contributors including our core team."
  }, {
    "heading": "community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
  }],
  "headings": [{
    "id": "schedule-your-long-running-tasks-with-confidence",
    "content": "Schedule your long-running tasks with confidence"
  }, {
    "id": "global-turbo",
    "content": "Global turbo"
  }, {
    "id": "declare-your-outputs-for-improved-clarity",
    "content": "Declare your outputs for improved clarity"
  }, {
    "id": "errors-only-output-mode-for-quieter-logs",
    "content": "“Errors only” output mode for quieter logs"
  }, {
    "id": "community",
    "content": "Community"
  }]
};
import __img0 from "./../../public/images/blog/turbo-1-7-0/turbo-inference.png";
import {Tabs, Tab} from '../../components/tabs';
import {Badge} from '#components/badge';
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
export const toc = [{
  depth: 2,
  url: "#schedule-your-long-running-tasks-with-confidence",
  title: _jsx(_Fragment, {
    children: "Schedule your long-running tasks with confidence"
  })
}, {
  depth: 2,
  url: "#global-turbo",
  title: _jsxs(_Fragment, {
    children: ["Global ", _jsx("code", {
      children: "turbo"
    })]
  })
}, {
  depth: 2,
  url: "#declare-your-outputs-for-improved-clarity",
  title: _jsxs(_Fragment, {
    children: ["Declare your ", _jsx("code", {
      children: "outputs"
    }), " for improved clarity"]
  })
}, {
  depth: 2,
  url: "#errors-only-output-mode-for-quieter-logs",
  title: _jsx(_Fragment, {
    children: "“Errors only” output mode for quieter logs"
  })
}, {
  depth: 2,
  url: "#community",
  title: _jsx(_Fragment, {
    children: "Community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    img: "img",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.7"
    }), "\n", "\n", _jsx(Date, {
      children: "Wednesday, January 11th, 2023"
    }), "\n", _jsx(Authors, {
      authors: ['gregsoltis', 'nathanhammond', 'tomknickman', 'anthonyshew', 'jaredpalmer', 'mehulkar', 'chrisolszewski', 'nicholasyang']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 1.7 focuses on improving developer experience by bringing more clarity to your tasks:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#schedule-your-long-running-tasks-with-confidence",
          children: _jsx(_components.strong, {
            children: "Improved support for long running tasks"
          })
        }), ": Use ", _jsx(_components.code, {
          children: "persistent: true"
        }), " to mark non-terminating tasks so that ", _jsx(_components.code, {
          children: "turbo"
        }), " can alert you if you have dependencies on them."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#declare-your-outputs-for-improved-clarity",
          children: _jsx(_components.strong, {
            children: "Better clarity for outputs"
          })
        }), ": You'll now always need to declare your task outputs, improving transparency to what your tasks will cache."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#global-turbo",
          children: _jsx(_components.strong, {
            children: "Globally installable"
          })
        }), ": Install once, use everywhere. Turborepo can now be installed globally, and ran from any directory, not just from your repo root."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#errors-only-output-mode-for-quieter-logs",
          children: _jsx(_components.strong, {
            children: "“Error only” output mode"
          })
        }), ": Quiet your output logs to only show when a task fails."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Update today by running ", _jsx(_components.code, {
        children: "npm install turbo@latest"
      }), ", or by ", _jsx(_components.a, {
        href: "#global-turbo",
        children: "installing globally"
      }), " ", _jsx(Badge, {
        children: "NEW"
      }), " and running the ", _jsx(_components.a, {
        href: "/docs/reference/turbo-codemod#set-default-outputs",
        children: _jsx(_components.code, {
          children: "set-default-outputs"
        })
      }), " codemod."]
    }), "\n", _jsx(_components.h2, {
      id: "schedule-your-long-running-tasks-with-confidence",
      children: "Schedule your long-running tasks with confidence"
    }), "\n", _jsxs(_components.p, {
      children: ["To avoid misconfigurations that could result in tasks that never run, you can now tell Turborepo about tasks that won't exit on their own (like ", _jsx(_components.code, {
        children: "dev"
      }), " scripts) with a ", _jsx(_components.code, {
        children: "persistent: true"
      }), " ", _jsx(_components.a, {
        href: "/docs/reference/configuration#persistent",
        children: "configuration option"
      }), ". When this config is set on a task, Turborepo will ensure no other task can depend on this task. This is useful for ", _jsx(_components.code, {
        children: "dev"
      }), " tasks or test runners with ", _jsx(_components.code, {
        children: "--watch"
      }), " flags."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "\t\"pipeline\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "\t\t\"dev\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+\t\t\t\"persistent\": true"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "\t\t}"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "\t}"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Previously, if ", _jsx(_components.code, {
        children: "Task B"
      }), " depended on a persistent ", _jsx(_components.code, {
        children: "Task A"
      }), ", ", _jsx(_components.code, {
        children: "Task B"
      }), " would never execute, because ", _jsx(_components.code, {
        children: "Task A"
      }), " never exited. By declaring ", _jsx(_components.code, {
        children: "Task A"
      }), " as ", _jsx(_components.code, {
        children: "persistent"
      }), ", Turborepo will prevent this error scenario from happening."]
    }), "\n", _jsxs(_components.p, {
      children: ["Before this release, we had been recommending the use of ", _jsx(_components.code, {
        children: "turbo run <task> --parallel"
      }), " for persistent tasks. With ", _jsx(_components.code, {
        children: "--parallel"
      }), ", ", _jsx(_components.code, {
        children: "turbo"
      }), " would ignore your dependency graph and execute all your tasks at once."]
    }), "\n", _jsxs(_components.p, {
      children: ["While ", _jsx(_components.code, {
        children: "--parallel"
      }), " did provide a helpful escape hatch, it meant that users had to tell Turborepo ", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "how"
        })
      }), " to run their tasks rather than declaring ", _jsx(_components.strong, {
        children: _jsx(_components.em, {
          children: "what"
        })
      }), " a task is."]
    }), "\n", _jsxs(_components.p, {
      children: ["Rather than throwing away your entire topological dependency graph, it's much more precise for Turborepo to keep your dependency graph while guaranteeing that you don't depend on a process that won't exit with ", _jsx(_components.code, {
        children: "persistent: true"
      }), "."]
    }), "\n", _jsxs(_components.h2, {
      id: "global-turbo",
      children: ["Global ", _jsx(_components.code, {
        children: "turbo"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["You can now run your Turborepo tasks from anywhere in your project once you've installed ", _jsx(_components.code, {
        children: "turbo"
      }), " globally. To do so, use:"]
    }), "\n", _jsxs(Tabs, {
      items: ["npm", "yarn", "pnpm"],
      storageKey: "selected-pkg-manager",
      children: [_jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --global"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " global"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --global"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), " will now work in any project. To find your local ", _jsx(_components.code, {
        children: "turbo"
      }), " version, ", _jsx(_components.code, {
        children: "turbo"
      }), " will walk through a few steps, always looking upward from your current directory:"]
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsx(_components.li, {
        children: "Find the nearest turbo.json."
      }), "\n", _jsxs(_components.li, {
        children: ["If one is not found, find the first ", _jsx(_components.code, {
          children: "package.json"
        }), " with a ", _jsx(_components.code, {
          children: "workspaces"
        }), " property."]
      }), "\n", _jsxs(_components.li, {
        children: ["If one is not found, find the first ", _jsx(_components.code, {
          children: "package.json"
        }), "."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Your globally installed version of ", _jsx(_components.code, {
        children: "turbo"
      }), " will only be used when a locally installed version of ", _jsx(_components.code, {
        children: "turbo"
      }), " does not exist or cannot be found."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "turbo-inference",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo --version"
      }), " and ", _jsx(_components.code, {
        children: "turbo bin"
      }), " will show you the version and binary location, respectively, of the copy of ", _jsx(_components.code, {
        children: "turbo"
      }), " that will execute your tasks.\nAdditionally, running with ", _jsx(_components.code, {
        children: "-vv"
      }), " or ", _jsx(_components.code, {
        children: "--verbosity=2"
      }), " will always show if your local, or global ", _jsx(_components.code, {
        children: "turbo"
      }), " is being used."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --version"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --verbosity=2"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "2023-01-11T10:49:04.042-0500"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [DEBUG] turborepo_lib::shim: No "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "local"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " turbo binary found at: /Users/knickman/Developer/vercel/my-awesome-monorepo/node_modules/.bin/turbo"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "2023-01-11T10:49:04.042-0500"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [DEBUG] turborepo_lib::shim: Running command as global turbo"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "1.7.0"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h2, {
      id: "declare-your-outputs-for-improved-clarity",
      children: ["Declare your ", _jsx(_components.code, {
        children: "outputs"
      }), " for improved clarity"]
    }), "\n", _jsxs(_components.p, {
      children: ["Previously, if you did not specify an ", _jsx(_components.code, {
        children: "outputs"
      }), " key for a task, Turborepo would automatically attempt to cache all files in the ", _jsx(_components.code, {
        children: "dist/"
      }), " and ", _jsx(_components.code, {
        children: "build/"
      }), " directories."]
    }), "\n", _jsxs(_components.p, {
      children: ["This worked well for ", _jsx(_components.code, {
        children: "build"
      }), " tasks of specific frameworks, but this implicit behavior did not scale well as it applied to ", _jsx(_components.em, {
        children: "all"
      }), " tasks. We've found that, across the many developers, teams, projects, and codebases using Turborepo, the assumption to automatically cache ", _jsx(_components.code, {
        children: "dist/"
      }), " and ", _jsx(_components.code, {
        children: "build/"
      }), " directories was causing problems for users."]
    }), "\n", _jsx(_components.p, {
      children: "In version 1.7, this behavior is removed and you will now need to explicitly tell turborepo what to cache."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  \"pipeline\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    \"build\": {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-inserted)",
                "--shiki-dark": "var(--shiki-token-inserted)"
              },
              children: "+     \"outputs\": [\"dist/**\", \"build/**\"]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["If you were relying on the default cache output in Turborepo versions below 1.7, you can get the same behavior by running the ", _jsx(_components.a, {
        href: "/docs/reference/turbo-codemod#set-default-outputs",
        children: _jsx(_components.code, {
          children: "@turbo/codemod set-default-outputs"
        })
      }), " codemod:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @turbo/codemod"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " set-default-outputs"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Also note that you will no longer need to specify ", _jsx(_components.code, {
        children: "outputs: []"
      }), " because not caching anything is now the default behavior. The codemod will also remove this configuration from your tasks."]
    }), "\n", _jsx(_components.h2, {
      id: "errors-only-output-mode-for-quieter-logs",
      children: "“Errors only” output mode for quieter logs"
    }), "\n", _jsxs(_components.p, {
      children: ["To bring visibility to errors, community member ", _jsx(_components.a, {
        href: "https://github.com/dobesv",
        children: "@dobesv"
      }), " contributed ", _jsx(_components.a, {
        href: "https://github.com/vercel/turbo/pull/2588",
        children: "a solution to only show errors instead of all logs from a task run"
      }), ". While debugging a pipeline, ", _jsx(_components.code, {
        children: "--output-logs=errors-only"
      }), " can be used to keep your signal-to-noise ratio high so you can focus on ensuring successful runs for your pipelines.\nThis can be used as a ", _jsx(_components.a, {
        href: "/docs/reference/configuration#outputlogs",
        children: "configuration option"
      }), " or as a ", _jsx(_components.a, {
        href: "/docs/reference/run#--output-logs-option",
        children: "CLI flag"
      })]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --output-logs=errors-only"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "community",
      children: "Community"
    }), "\n", _jsxs(_components.p, {
      children: ["Since releasing ", _jsx(_components.a, {
        href: "/blog/turbo-1-6-0",
        children: "Turborepo v1.6"
      }), " and merging with ", _jsx(_components.a, {
        href: "https://turborepo.com/pack",
        children: "Turbopack"
      }), ", we've seen incredible adoption and community growth:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "18.7k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "750k weekly NPM downloads"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["30 years of compute time saved through ", _jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Remote Caching on Vercel"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo is the result of the combined work of all of our contributors including our core team."
    }), "\n", _jsx(_components.p, {
      children: "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
